import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '312px',
    '& fieldset': {
      width: '100%',
    },
    '& .operandLeftInput': {
      width: '100%',
    },
    '& .operandRightInput': {
      width: '42%',
    },
    '& .operatorInput': {
      width: '16%',
    },
    '& .MuiOutlinedInput-root': {
      position: 'absolute',
      height: '30px',
    },
    '& .MuiFilledInput-root.Mui-disabled': {
      backgroundColor: theme.color.notsocoolgray,
      height: theme.spacer * 3,
      color: theme.color.black,
      borderRadius: `${2}px !important`,
    },
    '& .MuiFilledInput-adornedEnd': {
      paddingRight: theme.spacer,
      height: theme.spacer * 3,
    },
    '& .MuiButton-label': {
      fontSize: "13px",
      fontWeight: "500"
    },
    '& .when-text': {
      fontSize: "13px",
    },
  },
  ExpandMore: {
    '& .MuiSvgIcon-root': {
      width: '20px !important',
    },
  },
  operatorInput2: {
    '& .MuiFilledInput-input': {
      textAlign: 'center',
      padding: '0 !important',
    },
  },
  operandRightInput3: {
    '& .MuiSvgIcon-root': {
      width: '20px',
      height: '12px',
      paddingLeft: '8px',
    },
  },
  ListAlt: {
    marginBottom: theme.spacer * 1,
    display: 'flex',
    '& .MuiSvgIcon-root': {
      width: '20px !important',
    },
  },
  ListAltTrash: {
    marginBottom: theme.spacer * 1,
    display: 'flex',
    justifyContent: "center",
    '& .MuiSvgIcon-root': {
      width: '20px !important',
    },
    '& .trash-icon': {
      cursor:"pointer",
      marginLeft: `${theme.spacer * 0.5}px`,
      '& path': {
        fill: "#000000"
      }
    }
  },
  conditionFieldSet: {
    padding: theme.spacer,
    marginBottom: theme.spacer * 0,
    paddingBottom: theme.spacer * 2,
    backgroundColor: theme.color.coolgray10,
    borderRadius: theme.spacer * 0.5,
  },
  pl8: {
    paddingLeft: theme.spacer,
  },
  pt2: {
    paddingTop: theme.spacer / 4,
  },
  secionTitle: {
    width: '100%',
    height: '40px',
    backgroundColor: theme.color.coolgray10,
    paddingLeft: '17px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    cursor: 'pointer',
    boxShadow: 'none',
    '& span': {
      fontSize: '13px',
      color: '#000000',
    },
    '& svg': {
      width: '14px !important',
      marginRight: '16px',
    },
    justifyContent: 'space-between',
  },
  radioGroup: {
    '& .MuiFormControlLabel-label': {
      backgroundColor: 'transparent',
      paddingBottom: 0,
    },
  },
  sectionInput:{
    '& .Mui-disabled': {
      backgroundColor: 'rgb(205, 212, 228)',
    },
    '& .MuiInputBase-formControl': {
      height: 25
    },
  },
  sectionDelete:{
    '& img': {
      cursor:"pointer"
    }
  },
  conditionTitle: {
    justifyContent: "space-between",
    '& .trash-icon': {
      cursor:"pointer",
      marginLeft: theme.spacer,
      '& path': {
        fill: "#000000"
      }
    }
  },
  containerOperand: {
    marginTop: -19, 
    marginBottom: 8 
  },
  containerCases: {
    marginTop: 8
  },
  containerAddMore: {
    marginTop: 8
  },
  containerError: { 
    "& span": {
      marginLeft: '20%'
    }
    
  },
  formControl: {
    justifyContent: 'space-between',
    padding: '12px',
    width: '100%',
  },
  inlineField: {
    display: 'flex',
    marginBottom: '10px',
  },
  inlineFieldLabel: {
    width: '50%',
  },
  textButtonAlignment: {
    position: 'absolute',
    bottom: '20px',
  },
  textButton: {
    width: '52px',
    height: '28px',
    marginLeft: '10px',
    background: `${theme.color.notsocoolgray} !important`,
    borderRadius: '2px !important',
    '& .valueText': {
      fontSize: '18px !important',
      fontWeight: '400 !important',
    }
  },
  fieldControls: {
    backgroundColor: `white !important`,
    marginTop: `${theme.spacer * 1}px`,
    '& .MuiFilledInput-root.Mui-disabled':{
      backgroundColor: `white !important`,
    },
  },
  fieldControlsLHS: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: `${theme.spacer * 4}px`,
    marginTop: `${theme.spacer * 1}px`,
    background: `${theme.color.coolgray10} !important`,
    '& .MuiFilledInput-root.Mui-disabled':{
      height: `${theme.spacer * 4}px`,
    },
    '& svg': {
      fontSize: `14px`
    }
  },
  btnControls: {
    display: 'flex',
    paddingTop: theme.spacer,
    paddingBottom: theme.spacer,
    background: 'white !important',
  },
  noBackground: {
    background: 'white !important',
    '&:hover': {
      background: 'white !important',
    },
    '&:focus': {
      background: 'white !important',
    },
    '& .MuiFilledInput-root.Mui-focused': {
      background: 'white !important',
    },
  },
  formControlField: {
    margin: '5px 2px 20px 2px',
  },
  formControlFieldWithErr: {
    margin: '5px 2px 10px 2px',
  },
  subjControlFieldWithErr: {
    margin: '0px 2px 10px 2px',
  },
  error: {
    color: 'red',
  },
  addButton: {
    fontWeight: 400,
    fontSize: '13px',
    color: theme.color.black,
  },
  assignmentFields: {
    display: "flex",
    borderRadius: '4px',
    flexDirection: "column",
    marginTop: `${theme.spacer * 2}px`,
    paddingTop: `${theme.spacer * 1}px`,
    marginLeft: `${theme.spacer * 1}px`,
    marginRight: `${theme.spacer * 1}px`,
    paddingLeft: `${theme.spacer * 1}px`,
    paddingRight: `${theme.spacer * 1}px`,
    paddingBottom: `${theme.spacer * 1}px`,
    backgroundColor: theme.color.coolgray10
  }
}));

export default useStyles;
